module.exports = __webpack_public_path__ + "/img/233e48c5f4ad918b81070054d986797a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/head-icon-down-blue.png
 ** module id = 17
 ** module chunks = 0 4 5
 **/